import trackGlobalEventsEffect from './trackGlobalEventsEffect';
import initializeHistoryApiIntegration from '../historyApiIntegration/initializeHistoryApiIntegration';
import initializeObeyBackendRedirects from '../redirectManagement/initializeObeyBackendRedirects';

initializeHistoryApiIntegration();
initializeObeyBackendRedirects();
trackGlobalEventsEffect();
